
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, forwardRef, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter, inject } from "@angular/core";
import { TaskOptionComponent } from "../task-option.component";
import { TaskUtils } from "../../../../shared/task-utils";
import { TaskRepository } from "../../../../repository/task.repository";
import { DateFilterType } from "../../../../shared/task-enum";
import { DateType } from "../../../../models";
import { MatDialog } from "@angular/material/dialog";
import { TaskDatePickerComponent } from "../../../task-date-picker/task-date-picker.component";
import { take } from "rxjs";
import { TaskService } from "src/app/task/task.service";
import { NgTemplateOutlet } from "@angular/common";
import { MatList, MatListItem } from "@angular/material/list";
import { MatIcon } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";
import { LocaleDatePipe } from "../../../pipes/locale-date.pipe";

@Component({
    selector: "vp-new-vnctask-option-start-date",
    providers: [{
            provide: TaskOptionComponent,
            // eslint-disable-next-line
            useExisting: forwardRef(() => NewTaskStartDateOptionComponent)
        }],
    templateUrl: "new-option-start-date.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, MatList, MatListItem, MatIcon, TranslatePipe, LocaleDatePipe]
})
export class NewTaskStartDateOptionComponent extends TaskOptionComponent implements OnInit {
  private taskRepo = inject(TaskRepository);
  override changerDetectorRef: ChangeDetectorRef;
  override matDialog: MatDialog;
  private service = inject(TaskService);

  override id: string = "add-start-date";
  override triggerKey = "~";
  dateType = DateType.START_DATE;
  activate:boolean = false;

  @Output() selectedStartDate = new EventEmitter();
  @Output() selectActivate = new EventEmitter();

  constructor() {
    const changerDetectorRef = inject(ChangeDetectorRef);
    const matDialog = inject(MatDialog);

    super();
    this.changerDetectorRef = changerDetectorRef;
    this.matDialog = matDialog;


    this.service.cancelActivationOfTags.subscribe(res => {
      this.cancelActivateData();
    });
  }

  ngOnInit() {
    let items = this.taskRepo.getDateFilterItems(DateFilterType.StartDate);
    this.setItems(items);
  }

  override getPayload() {
    let value = this.getValue();
    if (!value || (value && !value.date)) {
      return { start_date: ""};
    }
    return { start_date: TaskUtils.getFormattedDate(value.date) };
  }

  selectActivateData() {
    this.activate = true;
    this.selectActivate.emit(this.activate);
  }
  cancelActivateData() {
    this.activate = false;
    this.selectActivate.emit(this.activate);
  }
  selectedDate(item){
      console.log("selected date", item);
      this.selectedStartDate.emit(item);
      this.activate = false;
      this.selectActivate.emit(this.activate);

  }

  openDatePickerLocal(type) {
    const dlg = this.matDialog.open(TaskDatePickerComponent, {
      maxWidth: "100%",
      autoFocus: false,
      panelClass: "vp-task-datepicker-dialog",
      data: { header: "", rangeStart: this.rangeStart}
    });
    dlg.afterClosed().pipe(take(1)).subscribe(res => {
      console.log("selected date from datepicker", res);
      if (res) {
        this.selectedDate({date: res, name: "find"});
      }
    });
  }


}
